<template>
  <div id="login-container" class="login-container">
    <div class="login-wrap">
      <div class="box">
        <div class="title">
          {{ getConfig("customerTitle") }}
          <div class="desc">
            {{ getConfig("customerDesc") || "请先登录" }}
          </div>
        </div>
        <div class="form" style="padding: 0px 10px">
          <el-form
            size="small"
            :model="loginModel"
            :rules="pwdRules"
            @submit.native.prevent
            ref="loginByPassword"
          >
            <el-form-item label="登录账号" prop="username">
              <el-input
                type="text"
                v-model="loginModel.username"
                auto-complete="off"
                placeholder="请输入登录账号"
              ></el-input>
            </el-form-item>
            <el-form-item label="登录密码" prop="password">
              <div @keyup.enter="submitLogin">
                <el-input
                  type="password"
                  v-model="loginModel.password"
                  auto-complete="off"
                  placeholder="请输入密码"
                  show-password
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div style="float: right">
                <el-button
                  type="primary"
                  :disabled="!loginModel.password"
                  :loading="submiting"
                  @submit.native.prevent
                  @click="submitLogin"
                >
                  登 录
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div
      v-if="getConfig('customerFooterText')"
      v-html="getConfig('customerFooterText')"
      class="wordwrap"
      style="margin-top: 10px; text-align: center"
    ></div>

    <el-dialog
      title="找到以下可登录的商户"
      :visible.sync="dialogVisible"
      width="420px"
    >
      <div style="min-height: 350px" v-loading="logining">
        <span>选择登录商户</span>
        <el-table :data="customerList" style="width: 100%">
          <el-table-column prop="name" label="登录商户" min-width="180">
          </el-table-column>
          <el-table-column prop="name" label="操作" width="120">
            <template slot-scope="scope">
              <el-link style="color: #3399ff" @click="doLoginClick(scope.row)">
                登录
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px; margin-bottom: 50px">
          <span style="color: #919191"> * 请选择要登录的商户管理后台 </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logining: false,
      submiting: false,
      dialogVisible: false,
      customerList: null,
      loginModel: {
        username: "",
        password: "",
      },
      pwdRules: {
        username: [
          {
            required: true,
            message: "请输入登录账号",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    loginStyleValue() {
      return {
        "--login-container-bg-image-url": this.getConfig("customerLoginBg")
      }
    }
  },
  methods: {
    setBgImage() {
      var loginContainer = document.getElementById("login-container");
      if (loginContainer) {
        let customerLoginBg = this.getConfig("customerLoginBg");
        if (customerLoginBg) {
          loginContainer.style.backgroundImage = `url(${customerLoginBg})`;
        } else {
          loginContainer.style.backgroundImage = "";
        }
      }
    },
    doLoginClick(customer) {
      this.logining = true;
      this.requestApi("biz.customer.account.auth.login", {
        customerGuid: customer.guid,
        customerUsername: customer.username,
        username: this.loginModel.username,
        password: this.loginModel.password,
        // password: this.hexMd5(this.loginModel.password)
      }, { showError: true }).then((resp) => {
        this.commitState({
          username: this.loginModel.username,
          accessToken: resp.data.token,
          accessLoggedIn: true,
        });
        this.openRoutePage("/");
      }).finally(() => {
        this.logining = false;
      });
    },
    submitLogin() {
      this.$refs.loginByPassword.validate((valid) => {
        if (valid) {
          this.submiting = true;
          this.requestApi("biz.customer.account.auth.customerList", {
            username: this.loginModel.username,
            password: this.loginModel.password,
            // password: this.hexMd5(this.loginModel.password)
          }, { showError: true }).then((resp) => {
            this.customerList = resp.data;
            if (this.customerList.length == 1) {
              this.doLoginClick(this.customerList[0]);
            } else {
              this.dialogVisible = true;
            }
          }).finally(() => {
            this.submiting = false;
          });
        }
      });
    },
  },
  mounted() {
    let username = this.readState("username");
    if (username) {
      this.loginModel.username = username;
    }
    this.setBgImage();
  },
};
</script>

<style lang="less" scoped>
@loginBoxWidth: 360px;
@loginBoxPadding: 30px;

.login-wrap {
  position: relative;
  z-index: 10;

  .box {
    width: @loginBoxWidth;
    margin: 0 auto;
    border: solid 1px #d1d1d1;
    background: #ffffff;
    border-radius: 6px;
    padding-bottom: @loginBoxPadding;

    .title {
      width: 100%;
      font-size: 26px;
      margin-top: 30px;
      margin-bottom: 30px;
      padding: 0 @loginBoxPadding;

      .desc {
        font-size: 14px;
        color: #919191;
      }
    }

    .form {
      margin: @loginBoxPadding / 2 @loginBoxPadding @loginBoxPadding
        @loginBoxPadding;
      width: calc(@loginBoxWidth - @loginBoxPadding * 2);
    }
  }
}

.login-container {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding-top: 30px;
  min-height: 100vh;
  background-color: #47778f;
  background-size: cover; /* 按比例拉伸至充满整个区域 */
  background-position: center; /* 居中显示背景图片 */
  background-repeat: no-repeat; /* 不重复平铺背景图片 */
}
</style>
